<div class="footer-container">
    <div class="footer-view">
        <div class="footer-logo">
            <img src="../../assets/images/capvizon_brand_logo.png" alt="">
        </div>  
        <div class="rights-and-terms">
            <div class="rights">
                <span class="copy-right">Capvizon | Copyright © 2024.</span>
                <span class="reserved">All rights reserved.</span>
            </div>
            <div class="terms-and-conditions">Terms and Conditions*</div>
        </div>    
    </div>
</div>
